import React from "react";
import { FiCheck, FiArrowRight } from "react-icons/fi";
import "../styles/pricing.css";

export default function Pricing() {
  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="section-title">Árak – egyszerű és átlátható</h2>
          <p className="section-subtitle">
            Nem bonyolítom túl: nincs eldugott költség, apróbetűs rész. Egy
            működő, igényes weboldalt kapsz fix áron, és ha szeretnéd, mellé
            azokat a marketing beállításokat, amik nélkül ma már nem érdemes
            online megjelenni.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {/* Weboldalkészítés */}
          <div className="col-12 col-md-6 col-lg-5">
            <div className="pricing-card h-100 mx-3 mx-lg-0">
              <div className="pricing-head">
                <h3 className="plan-title pt-3">Weboldalkészítés</h3>
                <div className="price">
                  <span className="amount">150 000</span>
                  <span className="currency">Ft</span>
                </div>
                <p className="plan-desc">
                  Egyszerű, modern, gyors bemutatkozó oldal — minden, amire
                  induláshoz szükséged van.
                </p>
              </div>

              <ul className="features">
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Egyszerű, modern landing oldal</span>
                </li>
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Információközlő, reszponzív, gyors</span>
                </li>
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Alap SEO és Google Ads bekötés</span>
                </li>
              </ul>

              <div className="pricing-actions pt-3">
                <p className="fineprint">
                  Az ár az <strong>1 oldalas</strong> bemutatkozó weboldalakra
                  vonatkozik. Több aloldal / extra funkció esetén az ár
                  változhat.
                </p>
              </div>
            </div>
          </div>

          {/* Marketing csomag */}
          <div className="col-12 col-md-6 col-lg-5">
            <div className="pricing-card h-100 featured mx-3 mx-lg-0">
              <div className="pricing-head">
                <h3 className="plan-title pt-3">Marketing csomag</h3>
                <div className="price">
                  <span className="amount">20 000</span>
                  <span className="currency">Ft</span>
                  <span className="per">/ hó</span>
                </div>
                <p className="plan-desc">
                  Napi egy kávé ára — cserébe folyamatos láthatóság azoknak,
                  akik épp a te szolgáltatásodat keresik.
                </p>
              </div>

              <ul className="features">
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Google Cégprofil beállítás</span>
                </li>
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Google Ads fiók létrehozása és összekötés</span>
                </li>
                <li className="feature-item">
                  <FiCheck aria-hidden="true" />
                  <span>Hirdetéskezelés és folyamatos optimalizálás</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
